import TemplateView from '../../../TemplateView'
import TwoLevelSelection from '../../../controls/selectorControls/two_level_selection'
import SharedUserButtonMenu from '../../../controls/selectorControls/at_shared_user_button_menu'
import UsersSelectorPanel from '../../../usersSelector/at_users_selector_panel'
import Ext from 'Ext'
import SelectorPanelWithApplyButtonHelper from '../../../controls/selectorControls/at_selector_panel_with_apply_button_object'
import HierarchySelectorDropdownButton from '../../../controls/selectorControls/at_hierarchy_selector_dropdown_button'
import SimpleUsersAndGroupsSelectionHelper from '../../../controls/selectorControls/selectionHelpers/simple_users_and_groups_selection_helper'

export default class UsersFilter extends TemplateView {
    constructor({
        onChange = ({userIds, groupIds, groupType, allSelected}) => {},
        createSelectionDescription,
        showInactiveCheckbox = true,
        setAllUsersIfNoneSelected = true,
    }) {
        super()

        this.state = {
            users: [],
            userIds: [],
            groupIds: [],
            groupType: null,
            userGroups: null,
            timeZoneGroups: null,
            allSelected: false,
        }

        this.params = {
            onChange,
            createSelectionDescription,
            showInactiveCheckbox,
            setAllUsersIfNoneSelected,
        }

        this.onStateDeeplyChanged(() => {
            this._initPanel()
        })
    }

    templateHtml() {
        return '<div class="userList_usersFilter commonVisibleFilterButton whiteBackground">' +
               '    <div class="mainIcon"></div>' +
               '    <div class="label usersSelector"></div>' +
               '    <div class="downIcon"></div>' +
               '</div>'
    }

    afterRender() {
        this.$usersSelector = this.find('.usersSelector')
    }

    _handleSelectionChanged = (data) => {
        this.params.onChange(data)
    }

    _initPanel() {
        this.$el.toggleClass('filtered', !this.state.allSelected)

        const PanelCtr = UsersSelectorPanel
        const ctrParams = {}
        Ext.apply(ctrParams, SelectorPanelWithApplyButtonHelper.getApplyButtonExtension(PanelCtr))
        this.panel = new PanelCtr({
            ...ctrParams,
            onCloseButtonClick: () => {
                UsersSelectorPanel.superclass.onCloseButtonClick.call(this.panel)

                const result = {
                    userIds: this.panel.getSelection().getSecondLevel(),
                    groupIds: this.panel.getSelection().getFirstLevel(),
                    groupType: this.panel.getGroupType(),
                    allSelected: !this.panel.isCustomOptionSelected(),
                }
                this._handleSelectionChanged(result)
            },

            makeSelectionHelper: this.panelMakeSelectionHelper,
            allItemsOptionLabelKey: 'user_groups_selector.smart.message.all_items.selected',
            showShowInactiveCheckbox: this.params.showInactiveCheckbox,
        })
        this.panel.initialize(
            !!this.state.userGroups,
            !!this.state.timeZoneGroups,
            this.state.users,
            this.state.userGroups,
            this.state.timeZoneGroups
        )

        this.panel.loadState({
            selection: new TwoLevelSelection(this.state.groupIds, this.state.userIds),
            groupType: this.state.groupType,
            additionalCheckBoxValue: false,
            optionValue: this.state.allSelected,
            showInactive: false
        })

        // if button not exists or linked menu already not actual - create new button and link with actual menu
        if (this.filterButton) {
            this.filterButton.menu = null // because ext.js cannot destroy menu without problems
            this.filterButton.destroy() // delete prev button
        }

        this.filterButton = new HierarchySelectorDropdownButton({
            renderTo: this.$usersSelector[0],
            menu: new SharedUserButtonMenu({
                panel: this.panel,
                additionalCls: 'ul_components_usersFilter_menu'
            }),
            menuAlign: "tl-bl?",
            menuAnchor: "td.middle-left-cell",
        })

        if (this.params.setAllUsersIfNoneSelected) {
            this.filterButton.setMenuHideCallback(() => {
                    this.panel.setAllUsersIfNoneSelected()
                }
            )
        }

        this.filterButton.on("menuhide", () => this.$el.removeClass("pressed"))
        this.filterButton.on("menushow", () => this.$el.addClass("pressed"))

        this.filterButton.updateButton()
    }

    panelMakeSelectionHelper = () => {
        let panel = this.panel
        panel.selectionHelper = new SimpleUsersAndGroupsSelectionHelper({
            itemNounSingularKey: panel.labelItemNounSingularKey,
            itemNounPluralKey: panel.labelItemNounPluralKey,
            showInactiveCount: true,
            showSingleItemInactiveText: false,
            userSelectorGroupsStrategy: panel.userSelectorGroupsStrategy,
            maxCharacters: panel.labelMaxChars,
            isNeededInformationAboutDisabledUsers: false,
            pleaseSelectMessageKey: "users_selector.short_no_users_selected",
            useNameForSingleItem: false,
            getDescription: (selection) => this.params.createSelectionDescription(selection, this.state.users),
        })
    }
}



// WEBPACK FOOTER //
// ./web/js/administration/userManagement/components/UsersFilter.js